import Vue from 'vue'
import store from '@/store'
import i18n from '@/i18n'

Vue.use({
  install() {
    Vue.prototype.$alertPopup = Vue.$alertPopup = {
      showSelectionLimitWarning(currentLength, maxLength) {
        store.dispatch('alert/addAlert', {
          type: 'warning',
          title: i18n.t('common.main_search.selection_limit_title'),
          text: i18n.t('common.main_search.selection_limit_text', {
            current: currentLength,
            limit: maxLength,
          }),
        })
      },
    }
  },
})
